import { FunctionComponent, useEffect } from "react";
import PricingTable from "../PricingTable";
import { usePricingController } from "../../../../utils/pricing/usePricingController";

interface IPricingContainerProps {
  audience: "b2b" | "b2c";
}

const PricingContainer: FunctionComponent<IPricingContainerProps> = ({
  audience,
}) => {
  const { viewModel, loadPricing } = usePricingController(audience);

  useEffect(() => {
    loadPricing();
  }, [loadPricing]);

  return <PricingTable audience={audience} viewModel={viewModel} />;
};

export default PricingContainer;
